// Guarantee exactly one trailing slash — call sites use `${BASE_URL}Endpoint`
export const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '') + '/';
export const ONBOARDING_URL = process.env.REACT_APP_ONBOARDING_BACKEND_URL;